import { LazyLoadImage } from 'react-lazy-load-image-component';

const PhotoListing_SimplePhotoThumb = (props) => {
    return (
        <div className='thumb simple-photo-thumb'>
            <a href={props.DestinationUrl}>
                <div className='thumb-img-wrapper' >
                    {props.ListingTypeForDisplay &&
                        <div className='listing-type'>{props.ListingTypeForDisplay}</div>
                    }
                    <LazyLoadImage {...props} src={props.ImageUrl} alt={props.AltText ? props.AltText : props.Title} />
                </div>
                <div className='thumb-details'>
                    <div className='title'>{props.Title ? props.Title : ''}&nbsp;</div>
                    <div className='desc'>{props.Description}</div>
                </div>
            </a>
        </div>
    );
};

export default PhotoListing_SimplePhotoThumb;